module.exports = "//static.hsappstatic.net/ContentComponents/static-2.65642/img/content-remix-post-publish/content-remix-ja.png"